// extracted by mini-css-extract-plugin
module.exports = {"pageNotFoundMainWrapper":"PageNotFound_pageNotFoundMainWrapper__2Gpxs","goToHomePage":"PageNotFound_goToHomePage__1iNY6","gotoRedirect":"PageNotFound_gotoRedirect__3Vn_J"};